import * as React from 'react'
import { INews } from 'src/type/news'
import { WithStyles, Theme, createStyles, withStyles } from '@material-ui/core'
import ReactHtmlParser from 'react-html-parser'
import { formatDate } from 'src/core/i18n/date'
import { compose } from 'redux'
import { convertUrlName, replaceDetteWithTaux } from 'src/shared/utils/helpers'
import Link from 'src/shared/Link/Link'
import { RootState } from 'src/core/redux/reducer'
import {connect} from 'react-redux'
import { config } from 'src/conf/config'
import { get } from 'lodash'

const styles = (t: Theme) => createStyles({
  });

  
interface IProps extends WithStyles<typeof styles>,
ReturnType<typeof state2props>,
ReturnType<typeof dispatch2props>{
    newsType: string;
    entity: INews;
}

/*
   Avoid validateDOMNesting(...)
*/
const NewsContent = (message: any) => (ReactHtmlParser(message))

class PublicNewsCard extends React.Component<IProps, {}> {
    render() {
        const {entity, mapName, newsType} = this.props
        const chips = get(entity, "category_actu")
        return (
            <Link to={`${config.baseUrl}/${newsType}/nos-actualites/${entity.id}/${convertUrlName(entity.title)}`}>
                <div className="public-card">
                    <header 
                        className="public-card__header" 
                        style={{backgroundImage: `url(${entity.img_url ? entity.img_url : config.IMG_BASE_PATH + "/news-default.jpg"})`}}
                    >
                        <div className="public-card__tag-infos">
                            <p className="public-card__publish-at">
                                {formatDate(entity.publish_at)}
                            </p>
                            {(mapName && chips && chips.length > 0) && 
                                <p className="public-card__categories">
                                    {
                                        chips.split(",").filter(c => c !== "economique").map(c => (
                                            replaceDetteWithTaux(mapName.get(c))
                                        )).join(", ")
                                    }
                                </p>
                            }
                        </div>
                    </header>
                    <section className="public-card__body">
                        <p className="public-card__title">{entity.title}</p>
                        <div className="public-card__content">
                            {NewsContent(entity.message)}
                        </div>
                    </section>
                </div>
            </Link>
        )
    } 
}

const dispatch2props = (dispatch: any, ownProps: any) => ({
})
const state2props = (state: RootState) => ({
    mapName: state.utils.mapCategories,
    enterprise: state.accountInfo.enterpriseSelected,
})

export default compose(    
    connect(state2props, dispatch2props),
    withStyles(styles)
)(PublicNewsCard)


// WEBPACK FOOTER //
// ./src/page/PublicNews/PublicNewsCard.tsx